import { render } from "./ResetPasswordComponent.vue?vue&type=template&id=4f04b96e&ts=true"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__